export default __webpack_public_path__ + "static/logo-d32e77945f97fe9e303b2a182ba233fa.png";